import { Send, Warning } from '@mui/icons-material';
import { Stack, TextField, Typography } from '@mui/material';
import { GenConfirmationDialog } from '@pinnacleautomotive/clarity-components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useApproveAndDeclineServices from '../hooks/useApproveAndDeclineServices';
import useOpenConfirmationDialog from '../hooks/useOpenConfirmationDialog';

export default function ConfirmationDialog() {
  const { t } = useTranslation('approvals');
  const [observation, setObservation] = useState('');
  const { open, closeConfirmationDialog } = useOpenConfirmationDialog();
  const { isLoading, patchOrder, services } = useApproveAndDeclineServices();

  useEffect(() => {
    if (!open) setObservation('');
  }, [open, setObservation]);

  return (
    <GenConfirmationDialog
      open={open}
      title={t('confirmTitle')}
      closeText={t('orders:noWait')}
      confirmText={t('sendApprovals')}
      confirmEndIcon={<Send />}
      titleIconColor={'warning'}
      onClose={closeConfirmationDialog}
      onRefuse={closeConfirmationDialog}
      titleIcon={Warning}
      isLoading={isLoading}
      onConfirm={() => patchOrder(observation)}
    >
      <Stack gap={2} alignItems="center" width="100%">
        <Stack>
          <Stack direction="row" gap={1} alignItems="center">
            <Typography variant="overline" flexGrow={1} textAlign="end">
              {t('numberServiceApproved')}
            </Typography>
            <Typography variant="subtitle2">
              {services.approvedServiceIds.length}
            </Typography>
          </Stack>
          <Stack direction="row" gap={1} alignItems="center">
            <Typography variant="overline" flexGrow={1} textAlign="end">
              {t('numberServiceDeclined')}
            </Typography>
            <Typography variant="subtitle2">
              {services.declinedServiceIds.length}
            </Typography>
          </Stack>
        </Stack>
        <Stack gap={0.5} width="100%" px={4}>
          <Typography variant="overline">{t('notes')}</Typography>
          <TextField
            placeholder={t('observationPlaceholder')}
            multiline
            rows={4}
            maxRows={4}
            value={observation}
            onChange={e => setObservation(e.target.value)}
            sx={{ width: '100%' }}
          />
        </Stack>
      </Stack>
    </GenConfirmationDialog>
  );
}
